import { render } from "./ValidateAssets.vue?vue&type=template&id=541ee3b0&scoped=true"
import script from "./ValidateAssets.vue?vue&type=script&lang=js"
export * from "./ValidateAssets.vue?vue&type=script&lang=js"

import "./ValidateAssets.vue?vue&type=style&index=0&id=541ee3b0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541ee3b0"]])

export default __exports__